export default class Login {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;

    this.recoverPasswordForm = document.querySelector('#RecoverPasswordForm');
    this.customerLoginForm = document.querySelector('#CustomerLoginForm');
    this.recoverPasswordLink = document.querySelector('#RecoverPassword');
    this.hideRecoverPasswordLink = document.querySelector('#HideRecoverPasswordLink');
    this.resetSuccess = document.querySelector('#ResetSuccess');

    this.hasLocalStorage = this._isLocalStorageSupported();

    if (this.recoverPasswordLink) {
      this.recoverPasswordLink.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.showRecoverPasswordForm();
      });
    }

    if (this.hideRecoverPasswordLink) {
      this.hideRecoverPasswordLink.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.hideRecoverPasswordForm();

        if (this.hasLocalStorage) {
          window.localStorage.removeItem('resettingPassword');
        }
      });
    }

    // Allow deep linking to recover password form
    if (window.location.hash === '#recover') {
      this.showRecoverPasswordForm();
    }

    let isResettingPassword = null;

    if (this.hasLocalStorage) {
      isResettingPassword = window.localStorage.getItem('resettingPassword');
    }

    if (isResettingPassword) {
      const isError = this.recoverPasswordForm ? this.recoverPasswordForm.querySelector('.errors') : null;
      if (isError) {
        if (this.resetSuccess) {
          this.resetSuccess.style.display = 'none';
        }
      } else {
        // The password reset email has been sent. Display information.
        if (this.resetSuccess) {
          this.resetSuccess.style.display = 'block';
        }

        if (this.hasLocalStorage) {
          window.localStorage.removeItem('resettingPassword');
        }
      }
    }
  }

  showRecoverPasswordForm = () => {
    if (this.recoverPasswordForm && this.customerLoginForm) {
      this.recoverPasswordForm.style.display = 'block';
      this.customerLoginForm.style.display = 'none';
    }

    // Now + 10 minutes (in milliseconds).
    const expiry = new Date(Date.now() + 10 * 60 * 1000);
    if (this.hasLocalStorage) {
      localStorage.setItem('resettingPassword', JSON.stringify({
        expiry: expiry.toISOString(),
      }));
    }
  }

  hideRecoverPasswordForm = () => {
    if (this.recoverPasswordForm && this.customerLoginForm) {
      this.recoverPasswordForm.style.display = 'none';
      this.customerLoginForm.style.display = 'block';
    }
  }

  _isLocalStorageSupported = () => {
    try {
      return typeof Storage !== "undefined" && window.localStorage && window.sessionStorage;
    } catch (e) {
      return false;
    }
  }
}
